<template>
  <div>
    <b-modal visible
             size="xl"
             centered
             no-close-on-backdrop
             no-close-on-esc
             hide-footer
             hide-header>
      <div class="row">
        <div class="col-2">
          <label class="label">
            Data do lote
          </label>
          <input v-model="lote.data_lote"
                 v-validate="`required`"
                 type="date"
                 name="data_lote"
                 :class="{ 'is-invalid': errors.has('data_lote') }"
                 class="form-control form-control-sm">
          <small v-if="errors.has('data_lote')"
                 class="text-danger">
            {{ errors.first('data_lote') }}
          </small>
        </div>
        <div class="col-2">
          <label class="label">
            Quantidade de papel
          </label>
          <input v-model="lote.quantidade_papel"
                 v-validate="`required|regex:[0-9]`"
                 type="number"
                 name="quantidade_papel"
                 class="form-control form-control-sm"
                 :disabled="propEdit"
                 :class="{ 'PapelSegurancaLoteAdicionar--invalid': errors.has('quantidade_papel') }"
                 @change="changeNumeroInicial()">
          <!--<v-select v-model="lote.quantidade_papel"
                    v-validate="`required|regex:[0-9]`"
                    :options="['1000', '2000']"
                    taggable
                    name="quantidade_papel"
                    :disabled="propEdit"
                    :class="{ 'PapelSegurancaLoteAdicionar&#45;&#45;invalid': errors.has('quantidade_papel') }"
                    @input="changeNumeroInicial()" />-->
          <small v-if="errors.has('quantidade_papel')"
                 class="text-danger">
            {{ errors.first('quantidade_papel') }}
          </small>
        </div>
        <div class="col-3">
          <!--          <label class="label">-->
          <!--            Tipo de papel-->
          <!--          </label>-->
          <!--          <b-form-radio-group-->
          <!--            v-model="lote.tipo_papel"-->
          <!--            size="md"-->
          <!--            :disabled="propEdit"-->
          <!--            :options="[{ text: 'Padrão', value: 'Padrão' }, { text: 'Mini', value: 'Mini', disabled: true }]"-->
          <!--            plain />-->
          <div class="d-flex justify-content-between">
            <label class="label">
              Tipo de impresso
            </label>
            <b-form-checkbox v-model="lote.selo"
                             name="check-button"
                             value="1"
                             :disabled="propEdit"
                             @change="clearCodigoServentia" 
                             switch>
              <label class="label">Selo</label>
            </b-form-checkbox>
          </div>
          <select v-if="!lote.selo"
                  v-model="lote.tipo_papel"
                  :disabled="propEdit"
                  class="form-control form-control-sm"
                  @change="verifyLote()">
            <option v-for="tipo in tipos_de_papeis"
                    :key="tipo.value"
                    :value="tipo.value">
              {{ tipo.label }}
            </option>
          </select>

          <select v-else
                  v-model="lote.tipo_selo"
                  :disabled="propEdit"
                  class="form-control form-control-sm"
                  @change="verifyLote()">
            <option v-for="tipo in tipos_de_selos"
                    :key="tipo.value"
                    :value="tipo.value">
              {{ tipo.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-2">
          <label class="label">CNS</label>
          <input v-model="lote.cns"
                 type="text"
                 disabled
                 class="form-control form-control-sm">
        </div>

        <div class="col-2">
          <label class="label">Código Serventia</label>
          <input v-model="lote.codigo_serventia"
                 v-validate="{ required: true, min: 4, max:4 }"
                 v-mask="9999"
                 :disabled="propEdit || !lote.selo"
                 name="codigo_serventia"
                 type="text"
                 placeholder="0000"
                 class="form-control form-control-sm">
          <small v-if="errors.has('codigo_serventia')"
                 class="text-danger">
            {{ errors.first('codigo_serventia') }}
          </small>
        </div>

        <div class="col-7">
          <div class="row">
            <div class="col">
              <label class="label">Número inicial e número final</label>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="row no-gutters">
                <div class="col-3 mr-1">
                  <input v-model="lote.prefixo_inicial"
                         v-validate="{ required: true, min: 2, max:2, regex: '^[A-Z]+' }"
                         v-uppercase
                         type="text"
                         placeholder="AA"
                         name="prefixo_inicial"
                         maxlength="2"
                         :disabled="propEdit || lote.disable_prefixo_inicial"
                         :class="{ 'is-invalid': !lote.disable_prefixo_inicial && errors.has('prefixo_inicial') }"
                         class="form-control form-control-sm"
                         @input="changePrefixo()">
                  <small v-if="!lote.disable_prefixo_inicial && errors.has('prefixo_inicial')"
                         class="text-danger">
                    {{ errors.first('prefixo_inicial') }}
                  </small>
                </div>
                <div class="col ml-1">
                  <input v-model="lote.numero_inicial"
                         v-validate="'required|regex:[0-9]'"
                         type="text"
                         placeholder="000000000"
                         name="numero_inicial"
                         maxlength="9"
                         :disabled="propEdit"
                         :class="{ 'is-invalid': errors.has('numero_inicial') }"
                         class="form-control form-control-sm"
                         @input="changeNumeroInicial()">
                  <small v-if="errors.has('numero_inicial')"
                         class="text-danger">
                    {{ errors.first('numero_inicial') }}
                  </small>
                </div>
              </div>
            </div>
            <div class="col-1 mt-1">
              até
            </div>
            <div class="col">
              <div class="row no-gutters">
                <div class="col-3 mr-1">
                  <input type="text"
                         placeholder="AA"
                         maxlength="2"
                         :value="lote.prefixo_final"
                         disabled
                         class="form-control form-control-sm">
                </div>
                <div class="col ml-1">
                  <input type="text"
                         :value="lote.numero_final"
                         placeholder="000000000"
                         disabled
                         maxlength="9"
                         class="form-control form-control-sm">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="PapelSegurancaLoteAdicionar--hr">

      <div class="row">
        <div class="col text-right">
          <button class="btn btn-light"
                  @click="closeModal()">
            Voltar
          </button>
          <button class="btn btn-secondary ml-2"
                  @click="saveLote()">
            {{ !propEdit ? 'Adicionar' : 'Atualizar' }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* libraries */
  import moment from 'moment'
  import { mapGetters } from "vuex"

  /* services */
  import PapelSegurancaLoteService from "@/services/PapelSeguranca/PapelSegurancaLoteService"

  export default {
    name: "PapelSegurancaLoteAdicionar",
    props: {
      propEdit: {
        type: Boolean,
        default: () => false
      },
      propLote: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj'
      })
    },
    data () {
      return {
        lote: {
          data_lote: moment(new Date()).format('YYYY-MM-DD'),
          quantidade_papel: 1000,
          cartorio_id: null,
          cns: null,
          prefixo_inicial: null,
          numero_inicial: null,
          prefixo_final: null,
          numero_final: null,
          tipo_papel: 'papel_de_seguranca_registro_civil',
          tipo_selo: 'selo_de_autenticacao',
          selo: 0,
          disable_prefixo_inicial: false
        },
        temp_lote: {
          data_lote: moment(new Date()).format('YYYY-MM-DD'),
          quantidade_papel: 1000,
          cartorio_id: null,
          cns: null,
          prefixo_inicial: null,
          numero_inicial: null,
          prefixo_final: null,
          numero_final: null,
          tipo_papel: 'papel_de_seguranca_registro_civil',
          tipo_selo: 'selo_de_autenticacao',
          selo: 0,
          disable_prefixo_inicial: false
        },
        tipos_de_papeis: [],
        tipos_de_selos: [],
      }
    },
    watch: {
      propLote () {
        this.init()
      },
      temp_lote: {
        handler (value) {
          if (!value.selo) {
            this.lote.disable_prefixo_inicial = ['ficha_de_firmas', 'traslado', 'apostilamento'].includes(value.tipo_papel)
          } else {
            this.lote.disable_prefixo_inicial = false
          }

          if (this.lote.disable_prefixo_inicial) {
            this.lote.prefixo_inicial = null
            this.lote.prefixo_final = null
          }
        },
        
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        const response = await PapelSegurancaLoteService.listTipos()
        this.tipos_de_papeis = response.tipos_de_papeis
        this.tipos_de_selos = response.tipos_de_selos

        if (this.propEdit) {
          this.lote = { ...this.propLote }
          this.lote.codigo_serventia = this.propLote.codigo_serventia ? ("0000" + this.propLote.codigo_serventia).slice(-4) : null
          this.lote.data_lote = moment(this.lote.data_lote).format('YYYY-MM-DD')

          if (this.propLote.selo) {
            this.lote.tipo_selo = this.propLote.tipo_papel
            this.lote.tipo_papel = 'papel_de_seguranca_registro_civil'
          }
        }

        // pegamos o cns e id do cartorio
        const { cartorio_id, cns } = this.cartorioObj

        // jogamos o cns e id do cartorio no formulario
        Object.assign(this.lote, { cartorio_id, cns })
        this.changePrefixo()
        this.changeNumeroInicial()
      },
      async saveLote () {
        const valid = await this.$validator.validate()

        if (valid) {
          // Caso não seja do tipo selo limpamos antes de emitir o lote que será cadastrado
          if(!this.lote.selo) {
            this.lote.codigo_serventia = null
          }

          this.$emit('onSaveLote', this.lote)
        }
      },
      changePrefixo () {
        this.lote.prefixo_final = this.lote.prefixo_inicial
      },
      changeNumeroInicial () {
        if (this.lote.numero_inicial) {
          this.lote.numero_final = +this.lote.numero_inicial + (+this.lote.quantidade_papel - 1)
        }
      },
      async closeModal () {
        this.$emit('onCloseModal')
      },

      verifyLote () {
        this.temp_lote = null // limpando lote temporario para ativar watch
        this.temp_lote = this.lote
      },

      clearCodigoServentia () {
        this.lote.codigo_serventia = null
      }
    }
  }
</script>

<style scoped lang="scss">
  .PapelSegurancaLoteAdicionar {
    &--hr {
      border-color: #074f7f;
    }

    &--invalid {
      border: 1px solid red !important;
      border-radius: 5px !important;
      border-color: #ed0909 !important;
    }
  }
</style>
